import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=263f3dee&scoped=true&lang=pug&"
import script from "./Recorder.vue?vue&type=script&lang=js&"
export * from "./Recorder.vue?vue&type=script&lang=js&"
import style0 from "./Recorder.vue?vue&type=style&index=0&id=263f3dee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263f3dee",
  null
  
)

export default component.exports